const cache = new Map();

export default function zroute(name, parameterValues = [], absolute = true) {
    let domain;
    let uri;
    let parameters;

    if (cache.has(name)) {
        ({ domain, uri, parameters } = cache.get(name));
    } else if (name.charAt(0) === '/') {
        domain = window.App.url;
        uri = name.slice(1);
    } else if (name.match(/^https?:\/\//)) {
        let segments = name.split('/');
        domain = segments.slice(0, 3).join('/');
        uri = segments.slice(3).join('/');
    } else {
        let route = window.App.routes[name];

        if (typeof route === 'undefined') {
            throw `Route [${name}] not defined.`;
        }

        domain = route.domain ? window.location.protocol + '//' + route.domain : window.App.url;
        uri = route.uri;

        for (const [parameter, custom] of Object.entries(route.bindings ?? {})) {
            uri = uri.replace(`{${parameter}}`, `{${parameter}:${custom}}`);
        }
    }

    let url = domain + '/' + uri;

    if (typeof parameters === 'undefined') {
        let parsed = [...url.matchAll(/{([^/:?]*):?([^/:?]*)(\??)}/g)] || [];
        parameters = [];

        for (const [, name, custom, optional] of parsed) {
            parameters.push({
                name,
                custom: custom || 'id',
                optional,
            });
        }
    }

    if (!cache.has(name)) {
        cache.set(name, {
            domain,
            uri,
            parameters,
        });
    }

    let searchParams = '';

    if (parameterValues === null || (!Array.isArray(parameterValues) && typeof parameterValues !== 'object')) {
        parameterValues = [parameterValues];
    }

    if (Array.isArray(parameterValues)) {
        for (let i = 0; i < parameters.length; i++) {
            parameters[i].value = typeof parameterValues[i] === 'undefined' ? null : parameterValues[i];
        }

        searchParams = parameterValues.slice(parameters.length).join('&');
    } else {
        parameterValues = Object.assign({}, parameterValues);

        for (const parameter of parameters) {
            const { name, custom } = parameter;

            if (Object.hasOwn(parameterValues, name)) {
                parameter.value = parameterValues[name];
                delete parameterValues[name];
            } else if (Object.hasOwn(parameterValues, custom)) {
                parameter.value = parameterValues[custom];
                delete parameterValues[custom];
            } else {
                parameter.value = null;
            }
        }

        searchParams = new URLSearchParams(parameterValues).toString();
    }

    let originalUrl = url;
    let missingParameters = [];

    for (const { name, custom, optional, value } of parameters) {
        if (value === null && !optional) {
            missingParameters.push(name);
        } else {
            const preparedValue = encodeURI(typeof value === 'boolean' ? (value ? 1 : '') : (value ?? ''));
            url = url.replace(`{${name}${optional}}`, preparedValue).replace(`{${name}:${custom}${optional}}`, preparedValue);
        }
    }

    if (missingParameters.length) {
        throw `Missing required parameters for [URL: ${originalUrl}] [Missing parameters: ${missingParameters.join(', ')}].`;
    }

    return (absolute ? url : new URL(url).pathname).replace(/\/*$/, '') + (searchParams.length > 0 ? '?' + searchParams : '');
}

Object.defineProperty(zroute, 'cache', {
    get: () => cache,
});
